import { memo } from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Emm = ({ mt /* mutationType*/, children }) => {

  const { t } = useTranslation();

  return (<Tooltip title={t(`modal_title_${mt}`.toLowerCase())}>
    <em className={mt}>
      {children}
    </em>
  </Tooltip>);
};

export default memo(Emm);
